export default (value) => {
  if (!value || value.length === 0) return '';
  return value.replace(/(<([^>]+)>)/ig, '');
};
